import type { Effect, Reducer, Subscription } from '@umijs/max';
import { getShopLogPage } from './service';

type ShopLogModelType = {
  namespace: 'shopLog';
  state: API.ShopLogState;
  effects: {
    fetchShopLogPageEffect: Effect;
    refreshDataEffect: Effect;
  };
  reducers: {
    setPageData: Reducer<API.ShopLogState>;
  };
  subscriptions: {
    setup: Subscription;
  };
};

const ShopLogModel: ShopLogModelType = {
  namespace: 'shopLog',

  state: {
    items: [],
    total: 0,
    current: 1,
    pageSize: 20,
  },

  effects: {
    fetchShopLogPageEffect: function* ({ payload }, { call, put }) {
      const res = yield call(getShopLogPage, payload);
      if (res.code === 0) {
        yield put({
          type: 'setPageData',
          payload: {
            items: res.data.items,
            total: res.data.total,
            current: res.data.current,
            pageSize: res.data.pageSize,
          },
        });
      }
    },

    refreshDataEffect: function* ({ payload }, { call, put }) {
      const res = yield call(getShopLogPage, payload);
      if (res.code === 0) {
        yield put({
          type: 'setPageData',
          payload: {
            items: res.data.items,
            total: res.data.total,
            current: res.data.current,
            pageSize: res.data.pageSize,
          },
        });
      }
    },
  },

  reducers: {
    setPageData(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },

  subscriptions: {
    setup({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === '/shopManage/shopLog') {
          // 页面初始化时不自动加载数据，由组件控制
        }
      });
    },
  },
};

export default ShopLogModel;
